import type { CustomerType } from './customerAccount';

export interface DriverLinkedCustomerSummary {
  id: number;
  type: CustomerType;
  displayName: string;
  legalName?: string | null;
  contactPersonName?: string | null;
  active?: boolean | null;
}

export interface DriverRecord {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  status: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'BANNED';
  dateOfBirth?: string | null;
  personalIdNumber?: string | null;
  driverLicenseNumber?: string | null;
  licenseIssueDate?: string | null;
  licenseExpiryDate?: string | null;
  licenseCategories?: string | null;
  notes?: string | null;
  preferredLanguage?: string | null;
  emailNotifications?: boolean | null;
  smsNotifications?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  totalReservations: number;
  totalRentals: number;
  linkedCustomer?: DriverLinkedCustomerSummary | null;
  linkedCustomers?: DriverLinkedCustomerSummary[];
}

export interface DriverSaveRequest {
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber: string;
  dateOfBirth?: string;
  personalIdNumber?: string;
  driverLicenseNumber?: string;
  licenseIssueDate?: string;
  licenseExpiryDate?: string;
  licenseCategories?: string;
  notes?: string;
  preferredLanguage?: string;
  emailNotifications?: boolean;
  smsNotifications?: boolean;
  status?: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'BANNED';
  linkedCustomerId?: number | null;
}

export const createEmptyDriverForm = (): DriverSaveRequest => ({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  dateOfBirth: '',
  personalIdNumber: '',
  driverLicenseNumber: '',
  licenseIssueDate: '',
  licenseExpiryDate: '',
  licenseCategories: '',
  notes: '',
  preferredLanguage: 'en',
  emailNotifications: false,
  smsNotifications: false,
  status: 'ACTIVE',
  linkedCustomerId: null,
});
